import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PersonaDetailsResponseFragment = { id: string, type?: Types.UserSurveyResponseTypeEnum | null, status?: Types.UserSurveyResponseStatusEnum | null, entityId: string, recurrenceNumber?: number | null, surveyResponse?: { textResponse?: string | null, optionResponse?: Array<{ optionText: string, optionId: string }> | null, attachments?: Array<{ url?: string | null, kind: Types.MediaKindEnum }> | null } | null, survey?: { questionConfig: { surveyQuestions: Array<{ questionId?: string | null }> } } | null };


export type PersonaDetailsResponseFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type PersonaDetailsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.UserSurveyResponsesFilter>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type PersonaDetailsQuery = { userSurveyResponses?: { totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, type?: Types.UserSurveyResponseTypeEnum | null, status?: Types.UserSurveyResponseStatusEnum | null, entityId: string, recurrenceNumber?: number | null, surveyResponse?: { textResponse?: string | null, optionResponse?: Array<{ optionText: string, optionId: string }> | null, attachments?: Array<{ url?: string | null, kind: Types.MediaKindEnum }> | null } | null, survey?: { questionConfig: { surveyQuestions: Array<{ questionId?: string | null }> } } | null } }> | null } | null };

export const PersonaDetailsResponseFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonaDetailsResponse on UserSurveyResponseType {
  id
  type
  status
  entityId
  recurrenceNumber
  surveyResponse {
    textResponse
    optionResponse {
      optionText
      optionId
    }
    attachments {
      url
      kind
    }
  }
  survey {
    questionConfig {
      surveyQuestions {
        questionId
      }
    }
  }
}
    `;
export const PersonaDetailsDocument = /*#__PURE__*/ gql`
    query personaDetails($filters: UserSurveyResponsesFilter, $sort: [SortType!], $first: Float, $after: String) {
  userSurveyResponses(
    filters: $filters
    sort: $sort
    first: $first
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...PersonaDetailsResponse
      }
    }
  }
}
    ${PersonaDetailsResponseFragmentDoc}`;

export function usePersonaDetailsQuery(options?: Omit<Urql.UseQueryArgs<PersonaDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<PersonaDetailsQuery, PersonaDetailsQueryVariables>({ query: PersonaDetailsDocument, ...options });
};